import script from "./GridPropertiesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridPropertiesComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridPropertiesComponent.vue?vue&type=style&index=0&id=37404639&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37404639"]])

export default __exports__